<template>
  <div class="flex h-full justify-center items-center">
    <!-- <toggle-button
      :value="params.data.actionData.toggle"
      :color="{checked: '#35C76F', unchecked: '#EA5455', disabled: '#CCCCCC'}"
      class="mt-3 mr-1"
      @change="handleChange"
    /> -->
    <!-- <vs-switch color="success" v-model="toggle" @change="handleChange" class="mr-2 mt-2" style="vertical-align: top !important;" /> -->
    <!-- <vs-button
      color="primary"
      type="border"
      icon-pack="feather"
      icon="icon-eye"
      class="mr-2"
      @click="hanldeViewSidebar"
    ></vs-button> -->
    <vs-dropdown style="cursor: pointer;" vs-custom-content vs-trigger-click>
      <vs-button color="primary" type="border" icon-pack="feather" icon="icon-more-vertical"></vs-button>

      <vs-dropdown-menu>
        <!-- <vs-dropdown-item style="width: 100px;">&#43; Todo</vs-dropdown-item>
        <vs-dropdown-item>&#43; Note</vs-dropdown-item>
        <vs-dropdown-item>&#43; Meeting</vs-dropdown-item>
        <vs-dropdown-item>&#43; Email</vs-dropdown-item> -->
        <vs-dropdown-item @click="editData" v-if="params.colDef.CellRendererParams.checkEditPermission">Edit</vs-dropdown-item>
        <vs-dropdown-item @click="showPopUp(!showPopUpBool)">Delete</vs-dropdown-item>
        <vs-dropdown-item @click="hanldeViewSidebar">Preview</vs-dropdown-item>
        <vs-dropdown-item @click="sendEmail">Send Invitation</vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
    <vs-popup
        classContent="popup-example"
        title="Please Confirm"
        :active.sync="showPopUpBool"
      >
        <h4>Are you sure to delete the staff?</h4>
        <vs-row vs-type="flex" vs-justify="flex-end" class="mt-3">
          <vs-button class="mr-2" @click="haldleDelete()">Confirm</vs-button>
          <vs-button type="border" color="danger" @click="showPopUpBool = false"
            >Cancel</vs-button
          >
        </vs-row>
      </vs-popup>
  </div>
</template>
<script>
import { delete_users, sendInvitation } from '@/api/user'
import { mapActions } from 'vuex'
// import { ToggleButton } from 'vue-js-toggle-button'
export default {
  name: 'CellRendererActions',
  components: {
    // ToggleButton
  },
  props: {
    // localValue: actionData,
  },
  mounted () {
    this.action = this.params.data.actionData
    console.log(this.params)
  },
  data () {
    return {
      action: {},
      toggle: null,
      showPopUpBool: false
    }
  },
  methods: {
    ...mapActions([
      'SET_DELETE_ID',
      'SET_VIEW_LEADS_SIDEBAR',
      'SET_VIEW_LEADS_SIDEBAR_DATA',
      'SET_LEADS_TOGGLE_DATA'
    ]),
    // async handleChange () {

    //   try {
    //     const user_id = this.params.data.basic_details.operation_user_id


    //     const payload = {
    //       active_user: this.params.data.actionData.toggle ? 0 : 1

    //     }

    //     const data = update_user(user_id, payload)

    //     const storePayload = {
    //       row_details: this.params.data,
    //       toggle: !this.params.data.actionData.toggle
    //     }
    //     this.SET_LEADS_TOGGLE_DATA(storePayload)
    //     this.$vs.notify({
    //       title: 'Success',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'success'
    //     })
    //   } catch (e) {

    //     this.$vs.notify({
    //       title: 'Warning',
    //       text: e,
    //       ...this.warnProp()
    //     })
    //   }
    // },
    showPopUp () {
      if (this.params.data.basic_details.active_user != '1') {
        if (!params.colDef.CellRendererParams.checkDeletePermission) {
          this.$vs.notify({
            title: "Warning",
            text: "You don\'t have sufficient permission to perform this action'",
            ...this.warnProp(),
          });
        }
        this.showPopUpBool  = true
      } else {
        this.$vs.notify({
          title: "Warning",
          text: "Can\'t delete non actionable row",
          ...this.warnProp(),
        });
      }
    },
    async haldleDelete () {
      const deleting_id = this.params.data.basic_details.operation_user_id
      const payload = {
        deleteField: [deleting_id]
      }
      if (!this.params.data.actionData.toggle) {
        try {
          const customer_id = localStorage.getItem('customer_id')
          await delete_users(payload, customer_id)
          this.SET_DELETE_ID(deleting_id)

          this.$vs.notify({
            title: 'Staff Deleted',
            text: 'Staff Deleted Successfully',
            ...this.successProp()
          })
        } catch (error) {
          //
        }
      } else {
        this.$vs.notify({
          title: 'Warning',
          text: 'Can\'t remove an active staff. Please deactivate the staff first',
          ...this.warnProp()
        })
      }

    },
    // hanldeViewSidebar () {
    //   const viewbutton = true
    //   this.SET_VIEW_LEADS_SIDEBAR(viewbutton)
    //   this.SET_VIEW_LEADS_SIDEBAR_DATA(this.params.data)
    // },
    editData () {
      //
      this.$router.push({
        name: 'user-profile',
        params: { teacher_id: this.params.data.basic_details.operation_user_id, editable: true }
      })
    },
    hanldeViewSidebar () {
      const viewbutton = true
      this.SET_VIEW_LEADS_SIDEBAR(viewbutton)
      this.SET_VIEW_LEADS_SIDEBAR_DATA(this.params.data)
    },
    async sendEmail () {
      try {
        if (this.params.data.basic_details.active_user == 0) {
          this.$vs.notify({
            title: 'Warning',
            text: "Can\'t send invitation to disactivated staff",
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
          return false
        }
        const data = await sendInvitation(this.$store.getters.customerId, this.params.data.basic_details.operation_user_id)
        this.$vs.notify({
          title: 'Success',
          text: data.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      } catch (e) {
        this.$vs.notify({
          title: 'Success',
          text: e.data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        })
      }
    }
  }
}
</script>
